import {
  IFormattedRanksDetailedReportAdmin,
  IRanksDetailedReportAdmin,
} from '../types';

/**
 * this transformer function transforms the raw ranks detailed report admin data
 * coming from api according to what ui needs.
 */
export function formatBidEfficiencyData(
  data: IRanksDetailedReportAdmin
): IFormattedRanksDetailedReportAdmin {
  const {
    firstRank = 0,
    otherRanks = 0,
    secondRank = 0,
    thirdRank = 0,
    totalActiveAssetsCount = 0,
    totalWithBids = 0,
  } = data;

  const totalActivePercent = (
    (totalWithBids / totalActiveAssetsCount) *
    100
  ).toFixed(2);
  const firstRankPercentage = (
    (firstRank / totalActiveAssetsCount) *
    100
  ).toFixed(2);
  const secondRankPercentage = (
    (secondRank / totalActiveAssetsCount) *
    100
  ).toFixed(2);
  const thirdRankPercentage = (
    ((thirdRank + otherRanks) / totalActiveAssetsCount) *
    100
  ).toFixed(2);
  const otherRanksPercentage = (
    ((totalActiveAssetsCount - totalWithBids) / totalActiveAssetsCount) *
    100
  ).toFixed(2);

  const formatPercent = (value: number, total: number): string => {
    if (total === 0) {
      return '0.00%';
    }
    return `${((value / total) * 100).toFixed(2)}%`;
  };
  const pieChartFirstRankPercent = formatPercent(
    firstRank,
    totalActiveAssetsCount
  );
  const pieChartSecondRankPercent = formatPercent(
    secondRank,
    totalActiveAssetsCount
  );
  const pieChartThirdRankPercent = formatPercent(
    thirdRank + otherRanks,
    totalActiveAssetsCount
  );
  const pieChartNoPriceRanksPercent = formatPercent(
    totalActiveAssetsCount - totalWithBids,
    totalActiveAssetsCount
  );

  return {
    ...data,
    firstRank,
    firstRankPercentage,
    otherRanks,
    otherRanksPercentage,
    pieChartFirstRankPercent,
    pieChartNoPriceRanksPercent,
    pieChartSecondRankPercent,
    pieChartThirdRankPercent,
    secondRank,
    secondRankPercentage,
    thirdRank,
    thirdRankPercentage,
    totalActiveAssetsCount,
    totalActivePercent,
    totalWithBids,
  };
}
